export const redirectToLead = ({
  leadId,
  $location,
  $state,
}: {
  leadId: string | number;
  $state: { go(route: string, params: { [key: string]: any }): void };
  $location: angular.ILocationService;
}): void => {
  $state.go(getLeadRouteName({ $location }), { id: leadId });
};

export const getLeadUrl = ({
  leadId,
  $location,
  $state,
}: {
  leadId: string | number;
  $state: { href(route: string, params: { [key: string]: any }): string };
  $location: angular.ILocationService;
}): string => $state.href(getLeadRouteName({ $location }), { id: leadId });

export const getLeadRouteName = ({
  $location,
}: {
  $location: angular.ILocationService;
}): string => {
  const [, baseRoute] = $location.path().split('/');

  if (['leads', 'tasks', 'appeals'].includes(baseRoute)) {
    return `${baseRoute}.leadpopup`;
  }

  return 'leadpopup.view';
};
